module.exports = __webpack_public_path__ + "img/invoice.da01f056.svg";